// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cJJQfxuWBjN7HvUYTsEh{display:flex;flex-direction:row;flex-wrap:wrap;row-gap:8px;column-gap:5px;align-items:center}", "",{"version":3,"sources":["webpack://./src/aichat/views/UserChatMessageEditor.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,cAAA,CACA,WAAA,CACA,cAAA,CACA,kBAAA","sourcesContent":[".chatButtonsContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  row-gap: 8px;\n  column-gap: 5px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatButtonsContainer": "cJJQfxuWBjN7HvUYTsEh"
};
export default ___CSS_LOADER_EXPORT___;
